export default __webpack_public_path__ + "static/media/joy_boy.e878d86c.png";